import { CommonModule, NgFor, NgIf } from '@angular/common';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { InputMaskModule } from 'primeng/inputmask';
import { KeyFilterModule } from 'primeng/keyfilter';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-safe-taxi-checker',
  standalone: true,
  templateUrl: './safe-taxi-checker.component.html',
  imports: [NgIf, NgFor, FormsModule, HttpClientModule, CommonModule, InputMaskModule, KeyFilterModule, ReactiveFormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SafeTaxiCheckerComponent implements OnInit {

  @Output()
  public closeEvent = new EventEmitter<boolean>();

  @Input()
  public closeButton: boolean = true;

  public vehicleData: any = null;
  public showExp: boolean = false;
  public form: FormGroup;

  public photos: string[] = [
    'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FsafeTaxi%2Fimage%203.jpg?alt=media&token=ac1850c0-6617-442d-abe2-5958b4e17ae1',
    'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FsafeTaxi%2Fimage%204.jpg?alt=media&token=81688e6e-e716-4b1a-bc3c-dbd28dfbdeac',
    'https://firebasestorage.googleapis.com/v0/b/smart-city-gamc.appspot.com/o/imagenes%2FsafeTaxi%2Fimage%202.jpg?alt=media&token=17690b7a-fe99-4827-8d9a-4f81d455816a'
  ];

  constructor(private _loaderService: LoaderService,
              private _fb: FormBuilder,
              private _http: HttpClient,
              private _cdr: ChangeDetectorRef) {
    this.form = this._fb.group({
      plate: ['', [Validators.required, this.customPlateValidator]]
    });
  }

  ngOnInit(): void {
  }

  public showExplanation() {
    this.showExp = !this.showExp;
  }

  public verifyTaxi() {
    this._loaderService.show();
    const formData = new FormData();
    const headers = new HttpHeaders();
    const url = 'https://registrovehicular.cochabamba.bo/web-conductor';
    
    formData.append('placa', (this.form.value.plate).toUpperCase());

    this._http.post(url, formData, { headers }).subscribe(
      (data: any) => {
        this.vehicleData = data;
        
        this._loaderService.hide();
      },
      error => {
        console.error(error);
        this.vehicleData = null;
        this._loaderService.hide();
      }
    );
  }

  public customPlateValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const regex = /^\d{3,4}[A-Za-z]{3}$/;
    if (!value || !regex.test(value)) {
      return { invalidPlate: true };
    }
    return null;
  }

  public getCapitalizeString(str: string): string {
    if (!str) {
      return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  public reinitForm() {
    this.vehicleData = null;
    this.showExp = false;
    this.form.reset();
    this._cdr.detectChanges();
  }

  public getDriverPhoto(photoLink: string) {
    return `url(https://registrovehicular.cochabamba.bo/public/fotos/conductor/${photoLink})`;
  }

  public emitCloseEvent() {
    this.closeEvent.emit(true);
    this.vehicleData = null;
    this.showExp = false;
    this.form.reset();
    this._cdr.detectChanges();
  }
}
